export interface Environment {
  production: boolean;
  applicationServerPublicKey: string;
  apiUrl?: string;
}

export const environment: Environment = {
  production: import.meta.env.PROD,
  applicationServerPublicKey: `BPuDLHfR-sA5UmHkTzQ-uoBboh2yCuwG89msvi2der2RDzpRNh2vj0OaGvaO3X6BZII7_U65UVHAKanWddUsvO8`,
  apiUrl: import.meta.env.VITE_API_URL || '',
};
